export function getCatalogNames(units) {
    var result = [];
//    console.log('getCatalogNames result=',result);
    return result;
}

export function getCatalogEntries(name, st, viol_wt, objmin) {
//    console.log('getCatalogEntries name=',name,' st=',st,' viol_wt=',viol_wt,' objmin=',objmin);
    var result = [];
//    console.log('getCatalogEntries result=',result);
    return result;
}
